import React from "react";
import { Modal, Button } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import "./ModalImpago.css";

export default function ModalImpago({ show, onHide }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      size="md"
      dialogClassName="modal-impago"
    >
      <Modal.Header className="modal-impago-header">
        <Modal.Title className="modal-impago-title">
          <ExclamationTriangleFill className="me-2" />
          ¡Atención! Aviso de Impago
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-impago-body">
        <p className="modal-impago-subtitle">
          <strong>La clínica tiene pagos pendientes.</strong>
        </p>
        <p className="modal-impago-text">
          Si no regulariza su situación,{" "}
          <strong>el acceso al sistema será suspendido próximamente</strong>.
        </p>
        <p className="modal-impago-footer">
            Para evitar interrupciones, regularice sus pagos lo antes posible y{" "}
            <strong className="footer-destacado">comuníquese al 0918167339</strong>.
        </p>
      </Modal.Body>

      <Modal.Footer className="modal-impago-footer">
        <Button
          className="btn-cerrar"
          onClick={onHide}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
